import { apiConcurso } from './cliente';

// Voto popular — rotas públicas (sem login); tenant pelo X-Tenant-Slug, concurso vigente.
const base = '/api/v1/publico/voto-popular';

/** Votações populares das fases (estado, regras, quesitos, candidatos, placar) + chave do captcha. */
export const obterVotoPopular = () => apiConcurso.get(base);

/** Um candidato só, pelo código do QR code. */
export const obterCandidatoVotoPopular = (token) => apiConcurso.get(`${base}/candidato/${encodeURIComponent(token)}`);

/**
 * Envia o código de 6 dígitos para o e-mail, já com o voto:
 * { faseConcursoId, produtoId, email, cpf?, aceiteRegulamento, captchaToken?, aprovado?, notas?: [{ quesitoId, nota }] }
 */
export const pedirCodigoVotoPopular = (dados) => apiConcurso.post(`${base}/codigo`, dados);

/** Confirma o voto com o código. */
export const confirmarVotoPopular = (faseConcursoId, email, codigo) =>
  apiConcurso.post(`${base}/confirmar`, { faseConcursoId, email, codigo });
